module.exports = __webpack_public_path__ + "img/rtv_invoice_amount.ca5b532c.svg";